module.exports = __webpack_public_path__ + "static/media/header_bg_4.37e6afad.jpg";